import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { epinRoles } from '@/mocks/epin';

export default function EpinRoleDetails() {
  const [active, setActive] = useState(0);
  const role = epinRoles[active];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="各角色功能明细"
          subtitle="点击左侧角色，查看该角色可用的功能模块与权限边界。"
        />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-5 lg:gap-8 items-start">
            {/* 角色选择列表 */}
            <div className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible -mx-4 px-4 lg:mx-0 lg:px-0 pb-2 lg:pb-0">
              {epinRoles.map((item, idx) => {
                const isActive = idx === active;
                return (
                  <button
                    key={item.key}
                    type="button"
                    onClick={() => setActive(idx)}
                    className={`flex items-center gap-2.5 px-3.5 py-3 rounded-md border text-left whitespace-nowrap cursor-pointer transition-colors ${
                      isActive
                        ? 'bg-primary-500 border-primary-500 text-background-50'
                        : 'bg-background-50 border-background-200 text-foreground-700 hover:border-primary-300'
                    }`}
                  >
                    <span
                      className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md ${
                        isActive ? 'bg-background-50/20 text-background-50' : 'bg-background-100 text-primary-700'
                      }`}
                    >
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <span className="text-sm font-medium">{item.name}</span>
                  </button>
                );
              })}
            </div>

            {/* 角色明细内容 */}
            <div className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200">
              <div className="flex flex-wrap items-center gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-900">
                  <i className={`${role.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                  {role.name}
                </h3>
                <span className="px-3 py-1 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-600">
                  {role.scope}
                </span>
              </div>

              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                {role.summary}
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {role.modules.map((m) => (
                  <div key={m.title} className="p-4 rounded-md bg-background-50 border border-background-200">
                    <div className="flex items-start gap-2">
                      <span className="w-5 h-5 mt-0.5 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                        <i className="ri-check-line text-xs"></i>
                      </span>
                      <h4 className="text-sm font-semibold text-foreground-950 leading-snug">{m.title}</h4>
                    </div>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{m.desc}</p>
                  </div>
                ))}
              </div>

              {role.rule && (
                <div className="mt-6 flex items-start gap-2.5 p-4 rounded-md bg-accent-100/80 border border-accent-200">
                  <i className="ri-shield-check-line text-accent-900 mt-0.5"></i>
                  <p className="text-sm text-accent-900 leading-relaxed">{role.rule}</p>
                </div>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}